import React, { PureComponent, Fragment } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import 'cropperjs/dist/cropper.css';
import Cropper from 'react-cropper';
import { setNickname, setAvatar, getUploadToken, LITTLEFILEAPI } from '../../../services/api';

class Content extends PureComponent {
    static propTypes = {
        userInfo: PropTypes.object,
    };
    constructor(props) {
        super(props);

        const {
            userInfo: { nickname, avatar, avatar_tmp, avatar_status },
        } = this.props;

        const _avatar = avatar || avatar_tmp || '';

        this.state = {
            nickname,
            nameHasChanged: false,
            avatar: _avatar,
            avatar_status,
            avatarHasChanged: false,
            showErrorTips: false,
            errorTipsTxt: '',
            showUploadAvatar: !_avatar,
            showSplitLine: false,
            uploadAvatar: '',
            uploadAvatarName: '',
        };

        this.oldNickname = nickname;
    }

    handleNickNameChange = e => {
        const changeValue = e.target.value;

        this.setState({
            nameHasChanged: changeValue !== this.oldNickname,
            nickname: changeValue,
            showErrorTips: false,
            errorTipsTxt: '',
        });
    };

    checkNickName = uname => {
        const pattern = /^[a-zA-Z0-9\-_\u4E00-\u9FA5]{2,24}$/i;

        if (uname.match(/^1\d{10}$/) || uname.length < 2 || !pattern.test(uname)) {
            return false;
        }

        return true;
    };

    submitNickName = async e => {
        e.preventDefault();

        const { nickname, nameHasChanged } = this.state;

        if (nameHasChanged) {
            if (!this.checkNickName(nickname)) {
                // eslint-disable-next-line no-alert
                alert('用户昵称必须为2-24个中文、英文、数字、-、_组成。');
                this.setState({
                    showErrorTips: true,
                    errorTipsTxt: '昵称格式不正确',
                });
            } else {
                await setNickname({ nickname }, (errorcode, errortips) => {
                    console.error(errorcode, errortips);
                    this.setState({
                        showErrorTips: true,
                        errorTipsTxt: errortips,
                    });
                });
            }
        }
    };

    handleClickAvatar = () => {
        const { avatar_status } = this.state;

        if (avatar_status === 1) {
            alert('审核中，不能修改');
        } else {
            this.setState({
                showSplitLine: true,
                showUploadAvatar: true,
            });
        }
    };

    handleAvatarUpload = () => {
        const avatarImgFile = document.getElementById('avatarImg');
        const file = (avatarImgFile && avatarImgFile.files && avatarImgFile.files[0]) || null;

        let imgUrl = '';

        if (file) {
            const reader = new FileReader();

            reader.onload = e => {
                imgUrl = e.target.result;

                // 获取文件名
                const fileName = file.name;
                // 获取文件扩展名
                const ext = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length);

                if (ext && /^(jpg|png|jpeg)$/i.test(ext)) {
                    this.setState({
                        uploadAvatar: imgUrl,
                        uploadAvatarName: fileName,
                    });
                } else {
                    alert('图片格式错误');

                    return false;
                }
            };

            reader.readAsDataURL(file);
        }
    };

    updateAvatar = async () => {
        if (this.refs.copper) {
            const oneTimeTokenObj = await getUploadToken((code, tips) => {
                console.error(code, tips);
            });

            if (oneTimeTokenObj && oneTimeTokenObj.avatar_token) {
                const { avatar_token } = oneTimeTokenObj;
                const { uploadAvatarName } = this.state;
                let dataUrl = this.refs.copper.getCroppedCanvas().toDataURL();

                dataUrl = dataUrl.split(',')[1];
                dataUrl = window.atob(dataUrl);

                const ia = new Uint8Array(dataUrl.length);

                for (let i = 0; i < dataUrl.length; i++) {
                    ia[i] = dataUrl.charCodeAt(i);
                }

                const picBlob = new Blob([ia], { type: 'image/jpeg' });

                const uploadAvatarLength = picBlob.size;
                const formData = new FormData();

                formData.append('token', avatar_token);
                formData.append('length', uploadAvatarLength);
                formData.append('filename', picBlob, uploadAvatarName);

                const httprequest = new XMLHttpRequest();

                httprequest.onreadystatechange = async () => {
                    if (httprequest.readyState === 4) {
                        let resDoc = httprequest.responseText;

                        if (resDoc) {
                            try {
                                resDoc = JSON.parse(resDoc);
                            } catch (e) {
                                console.error(e);

                                resDoc = {};
                            }

                            const { url_out } = resDoc;

                            if (url_out) {
                                await setAvatar(
                                    {
                                        avatar: url_out,
                                    },
                                    () => {
                                        this.setState({
                                            avatar: resDoc.url_out,
                                            showSplitLine: false,
                                            showUploadAvatar: false,
                                        });

                                        alert('上传成功');
                                    },
                                    (code, tips) => {
                                        alert(tips);
                                    },
                                );
                            } else {
                                alert('上传失败');

                                return false;
                            }
                        }
                    }
                };
                httprequest.open('POST', `${LITTLEFILEAPI}/api/v1/webuploadimage/onetime`, true);
                httprequest.send(formData);
            }
        }
    };

    render() {
        const {
            nickname,
            nameHasChanged,
            showErrorTips,
            errorTipsTxt,
            showUploadAvatar,
            showSplitLine,
            avatar,
            uploadAvatar,
        } = this.state;

        return (
            <div className={styles.content}>
                <div className={styles.i_content}>
                    <div className={styles.i_content_inner}>
                        <div className={`${styles.i_main} ${styles.i_base_set} ${styles.clearfix}`}>
                            <div className={styles.i_form}>
                                <table className={styles.i_form_table}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p className={styles.label}>昵 称</p>
                                            </td>
                                            <td className={styles.mark}>:</td>
                                            <td colSpan="2" className={`${styles.input} ${styles.tips}`}>
                                                <p>
                                                    <input
                                                        type="text"
                                                        value={nickname || ''}
                                                        className={`${styles.input_dft} ${
                                                            showErrorTips ? styles.errorRedBorder : ''
                                                        }`}
                                                        style={{ height: 34, lineHeight: 34, width: 180 }}
                                                        onChange={this.handleNickNameChange}
                                                    />
                                                    {showErrorTips ? null : (
                                                        <a
                                                            onClick={this.submitNickName}
                                                            className={`${styles.btn_dft} ${
                                                                nameHasChanged ? styles.nameChangedBtn : ''
                                                            }`}>
                                                            提交
                                                        </a>
                                                    )}
                                                    <span
                                                        className={styles.i_icon_form_right}
                                                        style={{ display: 'none' }}
                                                    />
                                                    {showErrorTips ? (
                                                        <Fragment>
                                                            <span className={styles.i_icon_form_wrong} />
                                                            <span className={styles.wrong_txt}>{errorTipsTxt}</span>
                                                        </Fragment>
                                                    ) : null}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top' }}>
                                                <p className={styles.label}>头 像</p>
                                            </td>
                                            <td className={styles.mark} style={{ verticalAlign: 'top' }}>
                                                :
                                            </td>
                                            <td>
                                                <div className={styles.headPicBox}>
                                                    {avatar ? (
                                                        <div
                                                            className={styles.userAvatarBox}
                                                            onClick={this.handleClickAvatar}>
                                                            <img src={avatar} />
                                                            <div className={styles.editUserAvatar} />
                                                        </div>
                                                    ) : null}
                                                    {showSplitLine ? <div className={styles.splitLine} /> : null}
                                                    {showUploadAvatar ? (
                                                        <div className={styles.uploadBox}>
                                                            <input
                                                                type="file"
                                                                className={styles.uploadBtn}
                                                                id="avatarImg"
                                                                onChange={this.handleAvatarUpload}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                                {showUploadAvatar ? (
                                                    <p className={styles.uploadTip}>
                                                        提示:图片大小控制在2M以内，图片格式仅限JPG、JPEG、PNG，暂不支持动态头像；如果修改后看不到新的头像，请按CTRL+F5刷新。
                                                    </p>
                                                ) : null}
                                                {showUploadAvatar && uploadAvatar ? (
                                                    <Fragment>
                                                        <div className={styles.cropAvatarBox}>
                                                            <div className={styles.cropper}>
                                                                <Cropper
                                                                    style={{ height: 270, width: '100%' }}
                                                                    viewMode={1}
                                                                    ref="copper"
                                                                    src={uploadAvatar}
                                                                    preview=".uploadCropPreview"
                                                                    aspectRatio={1}
                                                                />
                                                            </div>
                                                            <div className={styles.previewUpload}>
                                                                <div
                                                                    className={`${
                                                                        styles.preview150Pic
                                                                    } uploadCropPreview`}
                                                                />
                                                                150x150
                                                                <div
                                                                    className={`${
                                                                        styles.preview100Pic
                                                                    } uploadCropPreview`}
                                                                />
                                                                100x100
                                                                <div
                                                                    className={`${
                                                                        styles.preview60Pic
                                                                    } uploadCropPreview`}
                                                                />
                                                                60x60
                                                            </div>
                                                        </div>
                                                        <div className={styles.updateAvatarBtnLine}>
                                                            <a
                                                                className={`${styles.btn_dft} ${styles.nameChangedBtn}`}
                                                                onClick={this.updateAvatar}>
                                                                更新
                                                            </a>
                                                        </div>
                                                    </Fragment>
                                                ) : null}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
